import { createSelector } from "reselect"
import { find, last, pick, chain, capitalize } from "lodash"
import { getExcelValue } from "helpers/csv"
import { sortData } from "helpers/contributorsSort"
import { getSortOrder } from "modules/factor-trends/selectors"
import { getFactorCategory } from "modules/factor-trends/selectors/factors"
import { getSelectedDate } from "modules/factor-trends/selectors/dates"
import { getAllCategoryItems } from "modules/factor-trends-risk/selectors/items"
import { getRiskHistory } from "modules/factor-trends-risk/selectors/risk"
import { computeRiskData } from "modules/factor-trends-risk/selectors/data"

const getContributorData = createSelector(
  [getAllCategoryItems, getRiskHistory],
  computeRiskData,
)

const getLastContributor = createSelector(
  [getContributorData],
  (data) => last(data),
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, date, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format("YYYY-MM-DD")) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format("YYYY-MM-DD"))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    return chain(items)
      .map(item => ({
        ...pick(item, "label", "categoryLabel", "id", "color", "favorite", "field", "isAggregated"),
        value: dayData[item.id],
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getCsvData = createSelector(
  [getDetails, getSortOrder, getFactorCategory, getSelectedDate],
  (details, groupOrder, factorCategory, selectedDate) => {
    const headerCells = ["Factor", "% Risk"]
    const rows = chain(sortData(details, groupOrder))
      .map(({ label, value }) => [label, getExcelValue(value, { percent: true })])
      .value()

    return {
      data: [headerCells, ...rows],
      fileName: `Factor Trends Risk ${capitalize(factorCategory)} Factors as of ${selectedDate}`,
      type: "Factors",
    }
  },
)
